module.exports = __webpack_public_path__ + "img/red_070.fb559873.png";